import React, { useState } from 'react'
import { Button, Grid, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup'
import colors from '../../../colors';
import { useFormik } from 'formik';
import { ReactComponent as IconClose } from '../../../../icons/closeButton.svg';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { sendGeneralRequest } from '../../../../features/generalRequest';
import { setGeneralMessage } from '../../../../features/global/globalDataSlice';
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../../../icons/lottieAnimations/smallLoading.json'
import { texts } from '../../../general/texts';
import OtpInput from 'react-otp-input';


const validationSchema = yup.object({
    newPin: yup
        .string(texts["message-invalid-pin-field"])
        .length(6, texts["message-invalid-pin-field"])
        .matches(/^\d{6}$/, texts["message-invalid-pin-field"])
        .required(texts["message-invalid-pin-field"]),
})

const ChangePin = ({ onBackButtonClick }) => {
    const dispatch = useDispatch()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const [isLoading, setIsLoading] = useState(false)

    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            newPin: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            setIsLoading(true)
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, pin: values.newPin }, baseUrlKey: 'auth', endpoint: 'UpdatePin' })).then(response => {
                if (response.payload.response.success) {
                    dispatch(setGeneralMessage({ type: 'success', message: 'PIN-i u ndryshua me sukses!' }))
                    setIsLoading(false)
                    formik.resetForm()
                }
            })
        }
    })

    const handleOtpChange = (field, value) => {
        formik.setFieldValue(field, value)
    };

    return (
        <form style={{ width: '100%' }}>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                mt={8}
            >
                <Grid container item md={6} xs={10} justifyContent={'right'} >
                    <Button sx={{ borderRadius: '20px', ":hover": { backgroundColor: colors.lightOrange } }} onClick={onBackButtonClick}><IconClose /></Button>
                </Grid>
    
                <Grid item md={12} xs={12} marginBottom={2} textAlign="center">
                    <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '2rem' }}>
                        {texts["button-change-pin"]}
                    </Typography>
                </Grid>
    
                <Grid container item md={12} sm={12} xs={12} justifyContent="center" alignItems="center">
                    <Grid container item md={4} sm={12} xs={12} flexDirection='column' mb={10} alignItems="center">
                        <Typography sx={{ color: colors.orange, fontSize: '1.2rem', fontFamily: 'GerberaMedium', mb: 2 }}>
                            {texts["placeholder-new-pin"]}
                        </Typography>
    
                        <OtpInput
                            value={formik.values.newPin}
                            onChange={(val) => handleOtpChange('newPin', val)}
                            numInputs={6}
                            isInputNum
                            inputStyle={{
                                width: '2rem',
                                height: '2.5rem',
                                fontSize: '1.5rem',
                                border: 'none',
                                borderBottom: '1px solid gray',
                                marginRight: '0.5rem',
                                outline: 'none',
                                textAlign: 'center',
                                fontFamily: 'GerberaLight',
                                color: colors.darkBlue,
                            }}
                            renderInput={(props) => <input {...props} type="password" />}
                        />
                        {formik.touched.newPin && formik.errors.newPin && (
                            <Typography color="error" sx={{ mt: 1, fontSize: '0.75rem' }}>
                                {formik.errors.newPin}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
    
                <Grid item md={12} xs={12} textAlign="center">
                    <Button
                        onClick={formik.handleSubmit}
                        sx={{
                            background: colors.gradientOrange,
                            color: colors.white,
                            width: '250px',
                            fontSize: '1rem',
                            fontFamily: 'GerberaBold',
                            textTransform: 'none',
                            mt: 3,
                            mb: 3
                        }}
                    >
                        {texts["button-continue"]}
                    </Button>
                </Grid>
    
                {isLoading && (
                    <Grid container justifyContent={'center'}>
                        <Grid container item md={1} xs={1}>
                            <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true} />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </form>
    );
    
}
export default ChangePin